var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.label))]),_c('b-form-select',{staticClass:"ml-1",attrs:{"options":_vm.options,"disabled":_vm.options.length <= 1},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }